import { Routes } from '@angular/router';
import { ShiveRoutes } from '../segments/route-segments';
import { TimetableOverviewComponent } from '../../../pages/reports/timetables/timetable-overview/timetable-overview.component';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { TimetableMonthsComponent } from '../../../pages/reports/timetables/timetable-months/timetable-months.component';
import { TimetableEntriesComponent } from '../../../pages/reports/timetables/timetable-entries/timetable-entries.component';

export const ReportRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.ReportsTimetable,
  },
  {
    path: ShiveRoutes.ReportsTimetable,
    component: TimetableOverviewComponent,
  },
  {
    path: `${ShiveRoutes.ReportsTimetable + UrlSegmentDelimiter + ShiveRoutes.ReportsTimetableMonthly + UrlSegmentDelimiter}:id`,
    component: TimetableMonthsComponent,
  },
  {
    path: `${ShiveRoutes.ReportsTimetable + UrlSegmentDelimiter + ShiveRoutes.ReportsTimetableTimeEntries + UrlSegmentDelimiter}:id`,
    component: TimetableEntriesComponent,
  },
];
